/*
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2019-12-12 11:00:33
 * @LastEditors: mrh
 * @LastEditTime: 2020-11-23 10:01:19
 */
const getters = {
  token: (state) => state.user.token,
  longitude: (state) => state.user.longitude,
  latitude: (state) => state.user.latitude,
  communityData: (state) => state.user.communityData,
  cateId: (state) => state.user.cateId,
  communityShopId: (state) => state.user.communityShopId,
  name: (state) => state.user.name,
  modifyOrderState: (state) => state.user.modifyOrderState,
  isRecommend: (state) => state.user.isRecommend,
  memberId: (state) => state.user.memberId,
  states: (state) => state.user.states,
  ambientType: (state) => state.user.ambientType,
  areaId: (state) => state.user.areaId,
  nickname: (state) => state.user.nickname,
  phone: (state) => state.user.phone,
  recommend: (state) => state.user.recommend,
  cityId: (state) => state.user.cityId,
};
export default getters